module.exports = __webpack_public_path__ + "static/media/yale.73ec1493.svg";